// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".no-protection-pre-eula .package-title{font-size:1.1875rem}", "",{"version":3,"sources":["webpack://./resources/js/components/other/NoProtection/NoProtectionPreEula.scss"],"names":[],"mappings":"AACE,uCACE,mBAAJ","sourcesContent":[".no-protection-pre-eula {\n  .package-title {\n    font-size: 1.1875rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
